import { render } from "./RoundButtonWithIcon.vue?vue&type=template&id=28f45958&scoped=true"
import script from "./RoundButtonWithIcon.vue?vue&type=script&lang=js"
export * from "./RoundButtonWithIcon.vue?vue&type=script&lang=js"

import "./RoundButtonWithIcon.vue?vue&type=style&index=0&id=28f45958&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f45958"]])

export default __exports__